<template>
	<div class='knd-main'>
		<div class='bg' ref='bgbubbles'>
			<canvas id="canvas"></canvas>
			<!-- <div id="blob" ref='blob'></div> -->
			<svg id="svg" width='0' height='0'>
			<defs>
				<filter id="colorChange">
					<feColorMatrix
						type = "matrix"
						values="1.00     0     0     0     0
								0     0.33     0     0     0
								0     0     0.38     0     0
								0     0     0     1     0 "/>
				</filter>
			</defs>
				</svg>
							
			<svg width="0" height="0" >
			<defs>
				<filter id="colorRight">
				<feColorMatrix
					type = "matrix"
					values="0     0     0     0     0
							0     0.87     0     0     0
							0     0     0.70     0     0
							0     0     0     1     0 "/>
				</filter>
			</defs>
			</svg>

			<!-- <img :src="getKoekjeBackground()" /> -->

			<!-- <svg id="koekkruimel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 620 620">
				<path d="m402.87,310c0,6.42-1.82,11.81-3.02,17.88-1.24,6.26,3.26,13.94.87,19.7-2.43,5.86-1.44,14.55-4.92,19.75-3.51,5.25-12.04,7.53-16.48,11.98-4.45,4.45-7.52,11.79-12.77,15.3s-11.09,8.54-16.95,10.97c-5.76,2.39-15.85-8.95-22.11-7.72s-11.06,11.07-17.49,11.07-13.49.63-19.56-.57-11.14-7.95-16.9-10.34c-5.86-2.43-12.65-3.25-17.86-6.74-5.25-3.51-13.94-4.14-18.39-8.59-4.45-4.45-3.19-14.4-6.71-19.65-3.49-5.21-6.42-10.64-8.85-16.5-2.39-5.76-2.25-12.05-3.48-18.3s-4.56-11.83-4.56-18.25,2.11-12.43,3.31-18.5c1.24-6.26-2.09-14.14.3-19.9,2.43-5.86,8.56-10.29,12.04-15.49,3.51-5.25,8.15-9.72,12.6-14.16,4.45-4.45,6.42-12.82,11.66-16.34,5.21-3.49,11.1-8.38,16.96-10.81s13.49-2.57,19.75-3.81,13.27,1.67,19.69,1.67,13.97-4.62,20.04-3.42c6.26,1.24,8.42,15.76,14.18,18.15,5.86,2.43,10.05,5.08,15.25,8.57,5.25,3.51,11.43,4.26,15.87,8.71,4.45,4.45,13.55,5.03,17.06,10.28,3.49,5.21.3,13.94,2.73,19.8,2.39,5.76,12.74,9.29,13.98,15.55,1.2,6.07-6.25,13.29-6.25,19.71Z" />
			</svg> -->
		</div>
			<!-- <div id="gooey" class='gooey' ref='gooey'></div> -->
		<div class='knd-loader' v-if="loading">
			Laden
		</div>

		<div class='knd-story' v-if="!loading" ref='bgkoekje' :style="{'background-image': this.koekjeBackgroundStyle}">
			<swiper
				:slidesPerView="1"
				:spaceBetween="30"
				:centeredSlides="false" 
				:grabCursor="true"
				:autoHeight="true"
				:style="{'--swiper-navigation-color': '#07034A','--swiper-pagination-color': '#07034A'}"
				@swiper="onSwiper"
				@slideChange="onSlideChange"
				:lazy="true" 
				class='knd-swiper'
			>

				<swiper-slide 
				class='knd-article__slide'
				>
					<Landing />
				</swiper-slide>

				<swiper-slide 
				class='knd-article__slide'
				>
					<Verantwoording />
				</swiper-slide>

				<swiper-slide 
					class='knd-article__slide'
					v-for="(question, index) in questions" 
					:class="{'knd-slide__even': index % 2 === 0}"
					:key="index +'-question'"
				>
					<Quiz :question="questions[index]" />
				</swiper-slide>

				<swiper-slide 
				class='knd-article__slide'
				>
					<Eindscherm  />
				</swiper-slide>

			</swiper>


		</div>
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import SwiperCore, { Lazy, Pagination } from 'swiper';

	SwiperCore.use([Pagination, Lazy]);

	import "swiper/swiper-bundle.min.css";
	import 'swiper/components/lazy/lazy.min.css'


	import './scss/index.scss'
	import Landing from '@/components/landing';
	import Verantwoording from '@/components/verantwoording';
	import Quiz from '@/components/quiz';
	import Eindscherm from '@/components/eindscherm';

	import Bubbles from '@/components/background/bubbles.js';
	import Blob from '@/components/background/blob.js';
	// import Gooey from '@/components/background/gooey.js';

export default {
	name: 'App',
	components:{
		Landing,
		Verantwoording,
		Quiz, 
		Eindscherm,
		Swiper,
		SwiperSlide,
	},
	data: function() {
		return {
			loading: true,
			max: 0,
			height: 0,
			koekjeBackgroundIndex: 0,
			koekjeBackgroundStyle: '',
			koekjeBackgroundTimeout: undefined,
		}
	},
	watch: {
		'$store.state.currentIndex': function() {
			this.swiper.allowSlideNext = true;
			this.swiper.slideNext();
			window.scrollTo({top: 0});
			this.swiper.allowSlideNext = false;
			this.max = Math.max(this.max, this.swiper.activeIndex);
		}
	},

	computed: {
		currentPage() {
			return this.$store.getters.currentPage;
		},

		questions() {
			return this.$store.getters.vragen;
		},

		currentQuestion() {
			return this.$store.getters.currentQuestion;
		}		
	},
	mounted: function() {
		this.updateHeight();

			window.addEventListener('resize', this.debounce(() => this.updateHeight(),
			200, false), false);

		this.$store.dispatch('loadData')
		.then(() => {
			this.loading = false;
		});

		let bubblesBg = new Bubbles();

		this.startKoekjeBackgroundAnimation();
	},

	methods: {
		debounce(func, wait, immediate){
			var timeout;
			return () => {
				const context = this, args = arguments;
				const later = function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				const callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},

		updateHeight() {
			this.height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;
		},

		nextSlide() {
			
		},

		onSwiper(swiper) {
			this.swiper = swiper;
			this.swiper.allowSlideNext = false;
			this.swiper.allowSlidePrev = false;

			this.$store.dispatch('addSwiper', swiper)
		},
		onSlideChange() {
			// if(this.max > this.swiper.activeIndex) {
			// 	this.swiper.allowSlideNext = true;
			// } else {
			// 	this.swiper.allowSlideNext = false;
			// }
		},

		afterInit() {

		},

		startKoekjeBackgroundAnimation() {
			this.koekjeBackgroundTimeout = setInterval(() => this.switchKoekjeBackground(), 500);
		},

		stopKoekjeBackgroundAnimation() {
			clearTimeout(this.koekjeBackgroundTimeout);
		},

		switchKoekjeBackground() {
			const startKoek = require('@/assets/bgs/KOEKJE_BACKGROUND_KOEKJE_' + (this.koekjeBackgroundIndex + 1) + '.svg');
			const endKoek = require('@/assets/bgs/KOEKJE_BACKGROUND_KOEKJE_' + (this.koekjeBackgroundIndex + 2) + '.svg');
			this.koekjeBackgroundStyle = 'url(' + startKoek +'), url(' + endKoek + ')';

			this.koekjeBackgroundIndex++;

			if (this.koekjeBackgroundIndex > 18) this.koekjeBackgroundIndex = 0;
		},
	}
}
</script>